module.exports = {"product":"Service Catalogue","description":"Explore the offerings of EODC","author":"EODC <support@eodc.eu>"}